import React from 'react';
import { Link } from 'react-router-dom';
import { Banknote, CreditCard, Timer, CheckCircle2, ArrowRight } from 'lucide-react';
import { AnimatedSection, AnimatedGrid, AnimatedGridItem } from '../components/AnimatedSection';
export function Financing() {
  return <div className="w-full" data-id="element-144" data-mp="7ii7t1ypzk7q">
      {/* HERO SECTION */}
      <section className="relative bg-navy text-white py-24 md:py-32 overflow-hidden" data-id="element-145" data-mp="7h77jc4hguld">
        <div className="absolute inset-0 z-0" data-id="element-146" data-mp="3pvzm6flyejb6">
          <div className="absolute inset-0 bg-navy/90 mix-blend-multiply" data-id="element-147" data-mp="3unhmd1g5kfv3"></div>
          <div className="absolute inset-0 bg-grid-pattern opacity-20" data-id="element-148" data-mp="3upkm4d73xnd0"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center" data-id="element-149" data-mp="3g0elcksmfp30">
          <AnimatedSection data-id="element-150" data-mp="3kyg7xfp9a6j8">
            <Banknote className="w-12 h-12 text-accent mx-auto mb-6" data-id="element-151" data-mp="3kvkb5up59nwd" />
            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold leading-tight tracking-tight mb-6 max-w-4xl mx-auto" data-id="element-152" data-mp="36z6u2moivoif">
              Flexible <span className="text-accent" data-id="element-153" data-mp="2jbyibrputh5">Financing Options</span>{' '}
              Available
            </h1>
            <p className="text-lg md:text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-154" data-mp="3tq4yxdeoqokm">
              We offer both in-house financing and third-party financing options
              to help make electrical projects more affordable and accessible.
            </p>
          </AnimatedSection>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-2 bg-accent" data-id="element-155" data-mp="3fxytal95rzzf"></div>
      </section>

      {/* OVERVIEW SECTION */}
      <section className="py-20 md:py-28 bg-white" data-id="element-156" data-mp="3b06t73yd17k5">
        <div className="max-w-7xl mx-auto px-6" data-id="element-157" data-mp="3axau3cas0cu4">
          <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-158" data-mp="3pp36pgj6rcs5">
            <AnimatedSection data-id="element-159" data-mp="3kws0xx1rkwro">
              <h2 className="font-display text-3xl md:text-4xl font-bold text-navy mb-6 tracking-tight" data-id="element-160" data-mp="3kvqlzhhmnq4o">
                Financing Overview
              </h2>
              <div className="w-20 h-1.5 bg-accent mb-8" data-id="element-161" data-mp="2s95vej8z7i26"></div>
              <p className="text-lg text-slate-600 mb-6 leading-relaxed" data-id="element-162" data-mp="2s6jn2he9gyiw">
                Don't let budget constraints delay important electrical safety
                upgrades or necessary repairs. We believe that safe, reliable
                electrical systems should be accessible to everyone.
              </p>
              <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-163" data-mp="3vo6mj0szztn8">
                Our financing programs are designed to provide you with flexible
                payment options that fit your monthly budget, allowing you to
                get the work done now and pay over time.
              </p>

              <div className="space-y-4 mb-8" data-id="element-164" data-mp="37yvj1bk9jl5e">
                <div className="flex items-start gap-4 p-4 bg-slate-50 rounded-sm border border-slate-100" data-id="element-165" data-mp="37x0wxtx99mzq">
                  <Banknote className="w-6 h-6 text-accent shrink-0" data-id="element-166" data-mp="3cz00b3szwjwo" />
                  <div data-id="element-167" data-mp="n7bk1mg44b9o">
                    <h4 className="font-bold text-navy" data-id="element-168" data-mp="n84t4u2jncuz">In-House Financing</h4>
                    <p className="text-sm text-slate-600" data-id="element-169" data-mp="s66bfcs5b85e">
                      Direct financing options available for qualifying
                      projects.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-4 bg-slate-50 rounded-sm border border-slate-100" data-id="element-170" data-mp="27siavv39c4d0">
                  <CreditCard className="w-6 h-6 text-accent shrink-0" data-id="element-171" data-mp="22xceg2c8b7ao" />
                  <div data-id="element-172" data-mp="1y02rctcbb7q0">
                    <h4 className="font-bold text-navy" data-id="element-173" data-mp="1xyrpiz2fga1j">
                      Third-Party Financing
                    </h4>
                    <p className="text-sm text-slate-600" data-id="element-174" data-mp="1p07fsneuhapg">
                      Partnered with trusted lenders for competitive rates and
                      terms.
                    </p>
                  </div>
                </div>
              </div>
            </AnimatedSection>

            <AnimatedSection delay={0.2} className="bg-navy p-10 rounded-sm text-white relative overflow-hidden" data-id="element-175" data-mp="3eevnibchq4h5">
              <div className="absolute inset-0 bg-grid-pattern opacity-10" data-id="element-176" data-mp="39gao2e52botr"></div>
              <div className="relative z-10" data-id="element-177" data-mp="3hhib436jtt6j">
                <h3 className="font-display text-2xl font-bold mb-6" data-id="element-178" data-mp="3hemcsdqsh2hk">
                  Benefits of Financing
                </h3>
                <ul className="space-y-4" data-id="element-179" data-mp="37isra4v3dynn">
                  {['Get necessary electrical work done immediately', 'Preserve your cash and credit lines', 'Predictable monthly payments', 'Competitive interest rates', 'No prepayment penalties (on select plans)', 'Quick and easy application process'].map((benefit, i) => <li key={i} className="flex items-start gap-3" data-id="element-180" data-mp="2opoxmjhvjlt1" data-mpi={i}>
                      <CheckCircle2 className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-181" data-mp="2tro0ztdm6ipz" />
                      <span className="text-slate-300" data-id="element-182" data-mp="2fs67j0pdihaa">{benefit}</span>
                    </li>)}
                </ul>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </section>

      {/* PROCESS SECTION */}
      <section className="py-20 bg-slate-50 border-t border-slate-200" data-id="element-183" data-mp="1w5bcv8pn7zh2">
        <div className="max-w-7xl mx-auto px-6" data-id="element-184" data-mp="1w75xsn0wzrl5">
          <AnimatedSection className="text-center max-w-3xl mx-auto mb-16" data-id="element-185" data-mp="2a5m62iefdq5e">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-navy mb-6 tracking-tight" data-id="element-186" data-mp="255zsu8ylk9wl">
              Easy Application Process
            </h2>
            <div className="w-20 h-1.5 bg-accent mx-auto mb-6" data-id="element-187" data-mp="2k1pich2zr562"></div>
          </AnimatedSection>

          <AnimatedGrid className="grid md:grid-cols-3 gap-8" data-id="element-188" data-mp="2f3nyhtxqr1tj">
            {[{
            step: '01',
            title: 'Get an Estimate',
            desc: "First, we'll provide a detailed estimate for your electrical project."
          }, {
            step: '02',
            title: 'Apply for Financing',
            desc: "We'll help you submit a quick application with our financing partners."
          }, {
            step: '03',
            title: 'Get Approved & Start',
            desc: 'Receive fast approval decisions so we can begin your project without delay.'
          }].map((item, i) => <AnimatedGridItem key={i} className="bg-white p-8 rounded-sm shadow-sm border border-slate-100 text-center relative" data-id="element-189" data-mp="24fumrk894m26" data-mpi={i}>
                <div className="text-5xl font-display font-bold text-slate-100 absolute top-4 right-4" data-id="element-190" data-mp="2e78tabymem4t">
                  {item.step}
                </div>
                <Timer className="w-10 h-10 text-accent mx-auto mb-6 relative z-10" data-id="element-191" data-mp="2n7x6x5k3qkh6" />
                <h3 className="font-display font-bold text-xl text-navy mb-3 relative z-10" data-id="element-192" data-mp="2s79rfjni3fgl">
                  {item.title}
                </h3>
                <p className="text-slate-600 relative z-10" data-id="element-193" data-mp="svpbzs7s63le">{item.desc}</p>
              </AnimatedGridItem>)}
          </AnimatedGrid>

          <AnimatedSection delay={0.3} className="text-center mt-16" data-id="element-194" data-mp="q9zjl6ncwvrz">
            <Link to="/quote" className="bg-accent hover:bg-accent-hover text-white px-8 py-4 rounded-sm font-bold text-lg transition-colors inline-flex items-center gap-2" data-id="element-195" data-mp="qbapbc0d4dlq">
              Request Information <ArrowRight className="w-5 h-5" data-id="element-196" data-mp="bld67ahaie3e" />
            </Link>
          </AnimatedSection>
        </div>
      </section>
    </div>;
}